import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightHide12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSidebarRightHide12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.5 2H7v8H1.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5m9 0H8v8h2.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5m0-1A1.5 1.5 0 0 1 12 2.5v7a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 9.5v-7A1.5 1.5 0 0 1 1.5 1zM3.347 4.586a.5.5 0 0 1 .707-.707l1.768 1.767.354.354-.354.354L4.054 8.12a.5.5 0 1 1-.707-.707L4.761 6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightHide12);
